import { OperatorDocumentFile } from 'src/apis/document-exchange/types';
import { useAxios } from 'src/hooks/use-axios';

export function useFileDownloadUrl(url: string) {
  return useAxios(
    (axios, signal) =>
      axios.request<OperatorDocumentFile>({
        signal,
        method: 'GET',
        url,
      }),
    { neededOnPageLoad: true }
  );
}

export type FileDownloadUrlRequest = ReturnType<typeof useFileDownloadUrl>;
